import CtaLink from './CtaLink';
import Reveal from '@/components/base/Reveal';

const pillars = [
  {
    icon: 'ri-focus-3-line',
    title: 'Strategist, not a vendor',
    desc: 'Josh is the advisor behind the growth systems — focused on outcomes, not deliverables for the sake of it.',
  },
  {
    icon: 'ri-pie-chart-2-line',
    title: 'Measurable, not fluffy',
    desc: 'Every initiative is tied to leads, customers, and revenue. No vague metrics or vanity marketing.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted & direct',
    desc: 'Honest guidance on what will work for your business — and what will not.',
  },
];

export default function WhyJoshua() {
  return (
    <section
      id="about"
      className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 via-transparent to-background-300/40 blur-2xl" />
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src="/assets/images/joshuaw-hastings.jpg"
                    alt="Josh Hastings reviewing growth strategy and marketing data"
                    title="Josh Hastings — Growth Strategy & Consulting"
                    className="absolute inset-0 w-full opacity-70 h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <Reveal delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              Why Businesses Work With Josh
            </span>
            <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              The Strategist Behind the Growth
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              Josh Hastings is a growth strategist and consultant who helps
              established local and home-service businesses turn marketing into
              a measurable, predictable driver of revenue. He works as an
              advisor — not a faceless agency — bringing clarity, systems, and
              accountability to the businesses he partners with.
            </p>

            <div className="mt-8 space-y-4">
              {pillars.map((p) => (
                <div key={p.title} className="flex gap-4">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                    <i className={`${p.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-base text-foreground-950">
                      {p.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                      {p.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <CtaLink>Apply to Work With Me</CtaLink>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
